module.exports = __webpack_public_path__ + "static/img/host_default.aa0d5116.jpg";